import { render, staticRenderFns } from "./Scenario.vue?vue&type=template&id=67128198&scoped=true&"
import script from "./Scenario.vue?vue&type=script&lang=js&"
export * from "./Scenario.vue?vue&type=script&lang=js&"
import style0 from "./Scenario.vue?vue&type=style&index=0&id=67128198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67128198",
  null
  
)

export default component.exports